import React, { useContext, useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './admin.css'
import CountryContext from '../home/country_context';
import { Button } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { AdminNav } from './mini-components/admin_nav';
import { AdminSidePane } from './mini-components/admin-side-pane';
import { AdminMainContent } from './main-content';
import { RightPane } from './right-pane';
import { AdminMainWrapper } from './mini-components/admin-main-wrapper';

export const AdminMain = () => {
    const user = useContext(CountryContext)

    return (
        <AdminMainWrapper>
        <div className='row align-items-start '>
                <div className='col-sm-9    '>
                    <AdminMainContent />
                </div>
                <div className='col-sm-3 bg-white ' >
                    <RightPane />
                </div>
        </div>

        </AdminMainWrapper>
    )
};
